import { useTheme } from '@mui/material';
import { ILockerGateItem } from 'api/interfaces/lockerGate';
import { OpenLockIcon, PadLockIcon } from 'assets';
import { ClosedLockIcon } from 'assets/icons/ClosedLockIcon';
import { AlarmIcon } from 'components/alerts/AlarmIcon';
import { getIconColor } from 'components/alerts/alerts.logic';
import { AlarmType, DictPadLockMode, OpenStatus } from 'shared';
import { locationStore } from 'stores/locationStore/locationStore';

export const getLockerItemIcons = ({
	padLockDetails,
	lockerDetails,
	openStatus,
	hasElectricLock,
	hasAlarm,
	isArmed,
	alarmType,
	isMonitored,
}: ILockerGateItem) => {
	const theme = useTheme();

	const hasPadLockInPlace = Boolean(padLockDetails?.padLockInPlace);
	const rentalActive = Boolean(lockerDetails?.rentalDetails);
	const isPadLockPermanent = locationStore.selectedLocation?.dictPadLockMode === DictPadLockMode.Permanent;

	const padLockColor = rentalActive
		? isPadLockPermanent
			? theme.palette.secondary.main
			: theme.palette.error.light
		: theme.palette.inactive.main;

	const iconColor = getIconColor(openStatus, theme);
	const OpenStatusIcon = () => {
		return openStatus === OpenStatus.Closed ? (
			<ClosedLockIcon color={iconColor} />
		) : (
			<OpenLockIcon color={iconColor} />
		);
	};

	const icons = [
		{
			component: <PadLockIcon color={padLockColor} />,
			show: hasPadLockInPlace,
		},
		{
			component: <OpenStatusIcon />,
			// An unmonitored box has no real open status — showing a lock would state something we do not know.
			show: (hasElectricLock || hasAlarm) && alarmType !== AlarmType.Satel && isMonitored,
		},
		{
			component: <AlarmIcon isArmed={!!isArmed} />,
			show: hasAlarm && !(isPadLockPermanent && hasPadLockInPlace),
		},
	];

	return icons.filter(({ show }) => show).map(({ component }) => component);
};
